import PropTypes from 'prop-types';

import { Box } from '@hivebrite/design-system/Box';

import { Membership } from 'hb-react/shared/apps/Memberships/components/MembershipPurchaseCard';

import { Addons } from './components/Addons';
import { NavBar } from './components/NavBar';

const RegistrationStep = ({
  cartItems = [],
  memberships = [],
  addons = [],
  onCancel,
  onNext,
  onMembershipUpdate,
  registrationSubmitButtonText = s__(
    'Memberships|Proceed to Billing information',
  ),
}) => (
  <Box flexDirection="column" width="100%">
    <Box flexDirection="column">
      <Memberships
        memberships={memberships}
        onMembershipUpdate={onMembershipUpdate}
      />
    </Box>

    <Addons addons={addons} />

    <NavBar
      onCancel={onCancel}
      onNext={onNext}
      cartItems={cartItems}
      registrationSubmitButtonText={registrationSubmitButtonText}
    />
  </Box>
);

const Memberships = ({ onMembershipUpdate, memberships = [] }) =>
  memberships.map((membership) => (
    <Box key={membership.id} mb={4}>
      <Membership
        membership={membership}
        onAutomaticRenewal={(paymentOption) =>
          onMembershipUpdate({ membership, paymentOption })
        }
        onPaymentOptionChange={(paymentOption) =>
          onMembershipUpdate({ membership, paymentOption })
        }
      />
    </Box>
  ));

RegistrationStep.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  memberships: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      description: PropTypes.string.isRequired,
      price: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      currency: PropTypes.shape({
        code: PropTypes.string.isRequired,
        symbol: PropTypes.string.isRequired,
      }).isRequired,
    }),
  ),
};

export default RegistrationStep;
